<form>
  <!-- <div class="mb-3 row">
    <label
      for="table-complete-search"
      class="col-xs-3 col-sm-auto col-form-label"
      >Full text search:</label
    >
    <div class="col-xs-3 col-sm-auto">
      <input
        id="table-complete-search"
        type="text"
        class="form-control"
        name="searchTerm"
        [(ngModel)]="service.searchTerm"
      />
    </div>
    @if (service.loading$ | async) {
    <span class="col col-form-label">Loading...</span>
    }
  </div> -->
  <div class="table-responsive">
    <table class="my-2 w-100" style="table-layout: fixed">
      <thead>
        <tr>
          @for (column of config.columns; track column) {
          <th
            scope="col"
            [class]="
              'text-info text-uppercase fs-7 fw-semibold ' +
              'col-' +
              (column.width ? column.width : 3) +
              ' ' +
              'text-' +
              (column.align ? column.align : 'start')
            "
            style="padding: 0 !important"
          >
            {{ `${column.label}` | translate }}
          </th>
          <!-- <th scope="col" sortable="name" (sort)="onSort($event)">Country</th> -->
          }
        </tr>
        <tr>
          <td [attr.colspan]="config.columns.length" class="p-0">
            <div class="divider" style="margin-top: 10px"></div>
          </td>
        </tr>
      </thead>
      <tbody class="placeholder-glow">
        @if(config.data){ @for (data of config.data; track data) {
        <tr class="fw-semibold fs-9">
          @for (column of config.columns; track column) {
          <td
            [class]="
              'text-base ' +
              'col-' +
              (column.width ? column.width : 3) +
              ' ' +
              'text-' +
              (column.align ? column.align : 'start')
            "
            style="padding: 10px 0 !important"
          >
            @if(column.customComponent){
            <div [class]="`d-flex justify-content-${column.align}`">
              <ng-container
                *ngComponentOutlet="
                  getCustomComponent(column.customComponent, data)[0];
                  inputs: getCustomComponent(column.customComponent, data)[1]
                "
              />
            </div>
            } @else{ @if(column.key == 'actions'){
            <ng-container
              *ngComponentOutlet="
                getDefaultActionsCellComponent();
                inputs: {
                  config: column.actions
                    ? column!.actions
                    : defaultActionInputsConfig,
                  data: data
                }
              "
            />
            } @else{ @if(column.mask){
            {{ data[column.key] | dynamicMask : column.mask }}
            } @else{
            {{ data[column.key] }}
            } } }
          </td>
          }
        </tr>
        <tr>
          <td [attr.colspan]="config.columns.length" class="p-0">
            <div class="divider"></div>
          </td>
        </tr>
        } @empty {
        <tr>
          <td
            [attr.colspan]="config.columns.length"
            [class]="`py-4 text-center`"
          >
            <div
              class="d-flex flex-row align-items-center justify-content-center"
              style="min-height: 200px"
            >
              <div
                class="d-flex flex-column justify-content-center align-items-center gap-3"
                style="width: 60%"
              >
                @if(config.placeholders && config.placeholders.empty){
                <icon
                  [icon]="
                    config.placeholders.empty.icon ||
                    defaultConfig.placeholders.empty.icon
                  "
                  size="60"
                  color="primary"
                />
                <div class="d-flex flex-column gap-1">
                  <span class="fw-semibold">{{
                    "common.records-not-found.title"
                      | translate
                        : {
                            title: getDefaultEmptyTitleTranslate(
                              config.placeholders.empty.title
                            )
                          }
                  }}</span>
                  <span class="fw-medium text-info-dark fs-9">
                    {{
                      "common.records-not-found.description"
                        | translate
                          : {
                              title: getDefaultEmptyTitleTranslate(
                                config.placeholders.empty.title
                              )
                            }
                    }}
                  </span>
                </div>
                @if(config.placeholders.empty &&
                config.placeholders.empty.action){
                <button-component [config]="config.placeholders.empty.action" />
                } } @else {
                <icon
                  [icon]="defaultConfig.placeholders.empty.icon"
                  size="60"
                  color="primary"
                />
                <div class="d-flex flex-column gap-1">
                  <span class="fw-semibold">{{
                    "common.records-not-found.title-default" | translate
                  }}</span>
                  <span class="fw-medium text-info-dark fs-9">
                    {{
                      "common.records-not-found.description-default" | translate
                    }}
                  </span>
                </div>
                }
              </div>
            </div>
          </td>
        </tr>
        } } @else{ @for(i of getPlaceholderAmount(config.placeholders?
        config.placeholders.loading.rows:
        defaultConfig.placeholders.loading.rows); track i){
        <tr>
          @for (column of config.columns; track column) {
          <td
            [class]="
              'col-' +
              (column.width ? column.width : 3) +
              ' ' +
              ' text-' +
              (column.align ? column.align : 'start')
            "
            style="padding: 10px 0 !important"
          >
            <span
              [class]="`placeholder w-75 bg-${config.placeholders && config.placeholders.loading.color? `${config.placeholders.loading.color}`: `${defaultConfig.placeholders.loading.color}`}`"
            ></span>
          </td>
          }
        </tr>
        <tr>
          <td [attr.colspan]="config.columns.length" class="p-0">
            <div class="divider" style="margin-top: 10px"></div>
          </td>
        </tr>
        } }
      </tbody>
    </table>
  </div>

  <!-- <div class="d-flex justify-content-between p-2">
    <ngb-pagination
      [collectionSize]="(total$ | async)!"
      [(page)]="service.page"
      [pageSize]="service.pageSize"
    >
    </ngb-pagination>

    <select
      class="form-select"
      style="width: auto"
      name="pageSize"
      [(ngModel)]="service.pageSize"
    >
      <option [ngValue]="2">2 items per page</option>
      <option [ngValue]="4">4 items per page</option>
      <option [ngValue]="6">6 items per page</option>
    </select>
  </div> -->
</form>
